import { cn } from '@/lib/utils'

export default function StandingsDriverLapsCell({ laps }) {
  return (
    <div
      className={cn(
        'flex h-full w-[100px] items-center justify-center rounded-sm bg-neutral-blue-800 py-2 text-center tabular-nums md:h-[46px] md:w-full md:bg-neutral-blue-900 md:px-4',
        'border-none border-neutral-blue-800 md:border md:border-neutral-blue-900',
      )}
    >
      {laps || 0}
    </div>
  )
}
